import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, Table, TableBody, TableCell, TableHead, TableRow, Chip, CircularProgress, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import api from '../utils/api';

const fmtDate = iso => iso ? new Date(iso).toLocaleString('en-US',{month:'short',day:'numeric',hour:'2-digit',minute:'2-digit',second:'2-digit'}) : '-';

const ACTION_COLORS = {
  LOGIN:'#7c3aed', LOGOUT:'#6b778c', CREATE_TENANT:'#16a34a', UPDATE_TENANT:'#f59e0b',
  DELETE_TENANT:'#dc2626', DEPLOY:'#2f63ad', RUN_MIGRATIONS:'#0891b2', CREATE_USER:'#16a34a',
  UPDATE_USER:'#f59e0b', DELETE_USER:'#dc2626', CREATE_API_KEY:'#16a34a', REVOKE_API_KEY:'#dc2626',
};

export default function AuditLog() {
  const [logs, setLogs]     = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    api.get('/dashboard/audit').then(r => setLogs(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = logs.filter(l =>
    !search || l.action?.toLowerCase().includes(search.toLowerCase()) || l.username?.toLowerCase().includes(search.toLowerCase()) || l.resource?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box>
      <Box sx={{ mb:3 }}>
        <Typography variant="h4" sx={{ fontWeight:800, color:'#1e3a5f' }}>Audit Log</Typography>
        <Typography variant="body2" sx={{ color:'#6b778c' }}>Every action taken in the Control Panel</Typography>
      </Box>

      <TextField size="small" placeholder="Search by action, user, resource…" value={search} onChange={e => setSearch(e.target.value)}
        InputProps={{ startAdornment: <InputAdornment position="start"><SearchIcon sx={{ fontSize:18, color:'#9aa5b4' }} /></InputAdornment> }}
        sx={{ mb:2, width:340, '& .MuiOutlinedInput-root':{ borderRadius:'10px', backgroundColor:'#fff' } }} />

      <Paper elevation={0} sx={{ borderRadius:'16px', border:'1px solid rgba(47,99,173,0.08)', overflow:'hidden' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor:'#f8fafc' }}>
              {['Timestamp','User','Action','Resource','IP'].map(h => (
                <TableCell key={h} sx={{ fontWeight:700, fontSize:'0.78rem', color:'#5f6b7a', py:1.5 }}>{h}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? <TableRow><TableCell colSpan={5} sx={{ textAlign:'center', py:6 }}><CircularProgress size={28} /></TableCell></TableRow>
            : filtered.length === 0 ? <TableRow><TableCell colSpan={5} sx={{ textAlign:'center', py:6, color:'#9aa5b4' }}>No logs found.</TableCell></TableRow>
            : filtered.map(l => (
              <TableRow key={l.id} hover sx={{ '&:hover':{ backgroundColor:'rgba(47,99,173,0.02)' } }}>
                <TableCell sx={{ py:1, whiteSpace:'nowrap', fontSize:'0.78rem', color:'#6b778c', fontFamily:'monospace' }}>{fmtDate(l.created_at)}</TableCell>
                <TableCell sx={{ py:1, fontWeight:600, color:'#1e3a5f', fontSize:'0.82rem' }}>{l.username || 'API'}</TableCell>
                <TableCell sx={{ py:1 }}>
                  <Chip label={l.action} size="small" sx={{ height:22, fontSize:'0.7rem', fontWeight:700, borderRadius:'6px', backgroundColor:`${ACTION_COLORS[l.action]||'#6b778c'}18`, color: ACTION_COLORS[l.action]||'#6b778c' }} />
                </TableCell>
                <TableCell sx={{ py:1, fontSize:'0.8rem', color:'#445' }}>{l.resource || '-'}</TableCell>
                <TableCell sx={{ py:1, fontSize:'0.78rem', color:'#6b778c', fontFamily:'monospace' }}>{l.ip || '-'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
